export const SET_PAGE_LOADING = 'SET_PAGE_LOADING'
export const SET_FORM_LOADING = 'SET_FORM_LOADING'
export const SET_FORM_PROCESSING = 'SET_FORM_PROCESSING'
export const SET_FORM_DIRTY = 'SET_FORM_DIRTY'



// WEBPACK FOOTER //
// ./src/store/actions/states.js